import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios';
import s from './css/QuestionScreen.css';
import gs from '../global.css';
class QuestionScreen extends Component {
    state = {
        email: '',
        text: '',
        sending: false,
    };
    componentDidMount() {
        document.title = 'Sticknet | Ask a Question';
        window.scrollTo(0, 0);
    }
    send = () => {
        const { email, text } = this.state;
        if (email.includes('@') && text !== '') {
            this.setState({ sending: true });
            axios
                .post('/api/ask-question/', {
                email,
                text,
                anonymous: true,
            })
                .then(() => {
                this.props.history.push('/thank-you');
            })
                .catch((err) => console.warn('err', err.response.data));
        }
    };
    render() {
        const { sending } = this.state;
        return (React.createElement("div", { className: gs.main },
            React.createElement("div", { className: `${gs.screenContainer} ${gs.centerScreen}` },
                React.createElement("h1", { className: s.headerTitle }, "Ask a Question"),
                React.createElement("p", { className: s.have },
                    "Have a question? Make sure to check out our",
                    ' ',
                    React.createElement(Link, { className: s.link, to: '/faq' }, "FAQ"),
                    ". You can also send us your question below and we will get back to you as soon as possible, or send an email to support@sticknet.org."),
                React.createElement("p", { className: s.contact }, "Your contact Email that we can get back to you at"),
                React.createElement("input", { type: 'text', className: s.emailInput, placeholder: 'Your email', defaultValue: this.props.user ? this.props.user.email : '', onChange: (e) => this.setState({ email: e.target.value }) }),
                React.createElement("textarea", { className: s.input, placeholder: 'Leave your question here...', onChange: (e) => this.setState({ text: e.target.value }) }),
                React.createElement("button", { type: 'submit', onClick: this.send, style: { display: !sending ? 'block' : 'none' } },
                    React.createElement("p", { className: s.send }, "SEND")),
                React.createElement("div", { className: s.loader, style: { display: sending ? 'block' : 'none' } }))));
    }
}
const mapStateToProps = (state) => ({
    user: state.auth.user,
});
const connector = connect(mapStateToProps);
export default connector(QuestionScreen);
